module.exports = __webpack_public_path__ + "static/media/W09F2002-WEB5.16147ac9.svg";